async function loadTranslation({
    currency,
    defaultLanguage = 'en',
    i18nCoordinator,
    locale,
    namespace = 'baseApp',
}) {
    i18nCoordinator.init({
        currency,
        defaultCurrency: currency,
        defaultLocale: locale,
        locale,
        localeToCurrencyMap: {
            [locale]: currency,
        },
    });

    await i18nCoordinator.registerTranslatableApp({
        namespace,
        defaultLanguage,
        defaultLocale: locale,
        defaultCurrency: currency,
        supportedLocales: [
            locale,
        ],
        supportedCurrencies: [
            currency,
        ],
        translationFetchFn: () => {
            return require(`../translations/baseApp/${locale}.po`);
        },
    });

    return await i18nCoordinator.initI18nLibraries(locale, currency);
}

export default loadTranslation;
